import {
  DASHBOARD_LINK,
  ROUTE_PAGE_DASHBOARD,
} from '@components/Router/constants'
import { migrationAuthSelector } from '@store/migrationSelectors/authSelectors'
import type { Workspace } from '@store/reducers/dashboard/types'
import {
  getLastWorkspaceId,
  pickDefaultWorkspaceId,
} from '@store/reducers/dashboard/utils'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useMatch, useNavigate } from 'react-router-dom'

export const useDefaultWorkspaceRedirect = (
  workspaces: Workspace[],
  loading: boolean
) => {
  const navigate = useNavigate()
  const userId = useSelector(migrationAuthSelector.getUserId)
  const dashboardMatch = useMatch(ROUTE_PAGE_DASHBOARD)
  const noWorkspaceDashboard =
    dashboardMatch !== null && !dashboardMatch.params.workspaceId

  const defaultWorkspaceId =
    noWorkspaceDashboard && !loading
      ? pickDefaultWorkspaceId(workspaces, getLastWorkspaceId(userId))
      : null

  const redirecting = defaultWorkspaceId !== null

  useEffect(() => {
    if (!redirecting) {
      return
    }

    navigate(`${DASHBOARD_LINK}/${defaultWorkspaceId}`, { replace: true })
  }, [redirecting, defaultWorkspaceId])

  return { redirecting }
}
